<template>
  <v-container>
    <v-toolbar flat ma-0 pa-0>
      <v-toolbar-title>Analitička kartica kupca</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items
        style="display:grid;align-items:center;grid-template-columns:repeat(3, max-content);grid-column-gap:0.5rem;"
      >
        <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="show_print_options = true"
              v-bind="attrs"
              v-on="on"
            >
              <sabira_icon
                icon="file-pdf"
                fill="grey"
                class="mx-auto"
                :height="38"
                :width="38"
              ></sabira_icon
            ></v-btn>
          </template>
          <span>Kartica pdf</span>
        </v-tooltip>
        <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="show_email = true"
              v-if="client.id > 0"
              v-bind="attrs"
              v-on="on"
            >
              <sabira_icon icon="email_invoice" fill="grey"></sabira_icon>
            </v-btn>
          </template>
          <span>Pošalji karticu</span>
        </v-tooltip>
        <v-select
          v-model="selected_year"
          outlined
          :items="years"
          dense
          style="width:8rem"
          hide-details
        />
      </v-toolbar-items>
    </v-toolbar>
    <scrolly :style="{ width: '100%', height: '30rem' }">
      <scrolly-viewport viewport>
        <v-skeleton-loader
          type="table-heading, list-item-two-line, image, table-tfoot"
          v-if="is_loading"
        ></v-skeleton-loader>
        <v-data-table
          v-else
          :items="items"
          :headers="headers"
          disable-pagination
          hide-default-footer
          no-data-text="Podaci ne postoje za odabranu kategoriju"
        >
          <template v-slot:[`body.append`]>
            <tr>
              <td colspan="2" style="text-align: right;">
                Ukupno
              </td>
              <td style="text-align:right;">
                {{ $n(owes) }}
              </td>
              <td style="text-align:right;">
                {{ $n(paid) }}
              </td>
              <td style="text-align:right;">
                {{ $n(outstanding) }}
              </td>
            </tr>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ $moment(item.date).format("DD.MM.YYYY") }}
          </template>
          <template v-slot:[`item.paid`]="{ item }">
            {{ item.paid > 0 ? $n(item.paid) : null }}
          </template>
          <template v-slot:[`item.owes`]="{ item }">
            {{ item.owes !== null ? $n(item.owes) : null }}
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ $n(item.total) }}
          </template>
        </v-data-table>
      </scrolly-viewport>
      <scrolly-bar axis="y"></scrolly-bar>
    </scrolly>
    <v-dialog width="30rem" persistent scrollable v-model="show_print_options">
      <v-card>
        <v-card-title class="pb-0 mb-0"
          >Dodatni sadržaj u PDF dokumentu</v-card-title
        >
        <v-card-text class="pt-0 mt-0">
          <v-list color="transparent">
            <v-list-item>
              <v-checkbox
                label="Pečat"
                v-model="print_pecat"
                ripple
                hide-details
              ></v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                label="Potpis"
                v-model="print_potpis"
                ripple
                hide-details
              ></v-checkbox>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="show_print_options = false">Zatvori</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="print(false)">Prikaži</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <sabira_email
      :sender="email.sender"
      :message="email.message"
      :subject="email.subject"
      :attachments="email.attachments"
      :recipients="email.recipients"
      :visible="show_email"
      close="close_email_dialog"
    ></sabira_email>
  </v-container>
</template>
<script>
var QRCode = require("qrcode");
import { Scrolly, ScrollyViewport, ScrollyBar } from "vue-scrolly";
import jspdf from "jspdf";
import "jspdf-autotable";
export default {
  props: {
    client: {
      type: Object,
      default: null,
    },
  },
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    sabira_email: () => import("@/components/email"),
    Scrolly,
    ScrollyViewport,
    ScrollyBar,
  },
  data() {
    return {
      is_loading: true,
      sortBy: "date",
      sortDesc: false,
      show_print_options: false,
      print_pecat: true,
      print_potpis: true,
      selected_year: new Date().getFullYear(),
      show_email: false,
      logo_width: 0,
      logo_height: 0,
      logo_ratio: 1,
      visible: false,
      items: [],
      years: [
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3,
        new Date().getFullYear() - 4,
        new Date().getFullYear() - 5,
      ],
      email: {
        recipients: [
          {
            name: null,
            email: null,
          },
        ],
        sender: {
          name: null,
          email: null,
        },
        subject: null,
        message: null,
        attachments: [],
      },
      headers: [
        {
          text: "Datum",
          value: "date",
          width: 100,
        },
        {
          text: "Opis",
          value: "description",
        },
        {
          text: "Duguje",
          value: "owes",
          width: 120,
          align: "right",
        },
        {
          text: "Potražuje",
          value: "paid",
          width: 120,
          align: "right",
        },
        {
          text: "Saldo",
          value: "total",
          width: 120,
          align: "right",
        },
      ],
    };
  },
  watch: {
    selected_year: {
      handler() {
        this.build_ios();
      },
      immediate: false,
    },
    client: {
      handler() {
        this.build_ios();
      },
      immediate: true,
    },
    show_email: {
      handler() {
        if (this.show_email) {
          this.email.attachments = [];
          this.print(true);
        }
      },
    },
  },
  methods: {
    print(for_email) {
      var logo = this.$store.getters.user.account_logo;
      var document_header = this.$store.getters.user.account_document_header;
      var signature = this.$store.getters.user.account_signature;
      var stamp = this.$store.getters.user.account_stamp;
      var document_footer = this.$store.getters.user.account_document_footer;
      var signatory = this.$store.getters.user.account_signatory;

      const doc = new jspdf({
        orientation: "p",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
      });

      var header_start = 5;

      if (logo !== null) {
        var i_width = doc.getImageProperties(logo).width;
        var i_height = doc.getImageProperties(logo).height;
        var i_aspect = i_width / i_height;
        i_width = 11 * i_aspect;
        doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
        header_start += i_width + 10;
      }
      doc.setFont("Roboto-Regular");
      doc.setFontSize(9);
      if (document_header !== null) doc.text(document_header, header_start, 13);
      doc.setFontSize(10);
      doc.text(this.client.name.toString(), 10, 35);
      doc.text(
        this.client.address != null ? this.client.address.toString() : null,
        10,
        40
      );
      doc.text(
        this.client.city.toString() + ", " + this.client.country.toString(),
        10,
        45
      );
      if (this.client.id_number)
        doc.text("ID Broj: " + this.client.id_number.toString(), 10, 50);
      if (this.client.vat_number)
        doc.text("PDV Broj: " + this.client.vat_number.toString(), 10, 55);
      doc.text("Datum izvještaja:", 100, 35);
      doc.text(this.datum_kreiranja_formatiran + ". god.", 145, 35);
      doc.text("Mjesto izdavanja izvještaja:", 100, 40);
      doc.text(this.$store.getters.user.account_city, 145, 40);
      doc.autoTable({
        startY: 65,
        tableLineWidth: 0.2,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 11,
          fillColor: [240, 240, 240],
        },
        theme: "plain",
        columnStyles: {
          0: { halign: "center", valign: "middle" },
        },
        margin: { top: 0, left: 10, right: 10 },
        body: [
          {
            text:
              "Analitička kartica - evidentirane transakcije u " +
              this.selected_year +
              ". god.",
          },
        ],
      });

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          rowPageBreak: "avoid",
          fontSize: 9,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "left", valign: "top" },
          1: { halign: "left", valign: "top" },
          2: { halign: "right", valign: "top", cellWidth: "wrap" },
          3: { halign: "right", valign: "top", cellWidth: "wrap" },
          4: { halign: "right", valign: "top", cellWidth: "wrap" },
        },
        footStyles: {
          0: { halign: "left", valign: "top" },
          1: { halign: "right", valign: "top", cellWidth: "wrap" },
          2: { halign: "right", valign: "top", cellWidth: "wrap" },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        head: [
          [
            {
              content: "Datum",
              styles: {
                halign: "left",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: 35,
              },
            },
            {
              content: "Opis",
              styles: {
                halign: "left",
                valign: "middle",
                fillColor: [240, 240, 240],
              },
            },
            {
              content: "Duguje",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: 35,
              },
            },
            {
              content: "Potražuje",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: 35,
              },
            },
            {
              content: "Saldo",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: 35,
              },
            },
          ],
        ],
        body: this.items.map((x) => {
          return [
            this.$moment(x.date).format("LL"),
            x.description.toString(),
            x.owes !== null ? this.$n(parseFloat(x.owes)) : "",
            x.paid !== null ? this.$n(parseFloat(x.paid)) : "",
            this.$n(parseFloat(x.total)),
          ];
        }),
      });

      var footer_start_position = doc.autoTable.previous.finalY;
      var is_new_page = false;
      if (footer_start_position > 245) {
        is_new_page = true;
        doc.addPage();
        footer_start_position = 20;
      }

      doc.setFontSize(9);

      doc.autoTable({
        startY: footer_start_position + 1,
        tableLineWidth: 0,
        margin: {
          top: is_new_page ? 10 : 20,
          left: 10,
          right: 10,
          bottom: 30,
        },
        rowPageBreak: "avoid",
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0,
          fontSize: 9,
        },
        columnStyles: {
          0: { fillColor: [255, 255, 255], fontStyle: "bold" },
        },
        body: [
          [
            "Prema našim poslovnim knjigama na dan " +
              this.datum_kreiranja_formatiran +
              ". god." +
              " postoji iskazani saldo od " +
              parseFloat(this.paid - this.owes).toFixed(2) +
              " KM.",
          ],
        ],
      });

      var c_y_positions = [];

      if (this.print_pecat && stamp !== null) {
        var s_width = doc.getImageProperties(stamp).width;
        var s_height = doc.getImageProperties(stamp).height;
        var s_aspect = s_width / s_height;
        s_width = 30 * s_aspect;
        doc.addImage(
          stamp,
          "png",
          78,
          doc.autoTable.previous.finalY + 8,
          s_width,
          30,
          "pecat"
        );
        c_y_positions.push(doc.autoTable.previous.finalY + 40);
      }
      doc.text("M.P", 95, doc.autoTable.previous.finalY + 15);

      if (this.print_potpis && signature !== null) {
        var p_width = doc.getImageProperties(signature).width;
        var p_height = doc.getImageProperties(signature).height;
        var p_aspect = p_width / p_height;
        p_width = 12 * p_aspect;
        doc.addImage(
          signature,
          "png",
          135,
          doc.autoTable.previous.finalY + 15,
          p_width,
          12
        );
        c_y_positions.push(doc.autoTable.previous.finalY + 32);
      }
      doc.text(
        "______________________________",
        145,
        doc.autoTable.previous.finalY + 25
      );
      doc.text(signatory, 145, doc.autoTable.previous.finalY + 30);

      var max_y = 0;
      c_y_positions.forEach((p) => {
        if (p > max_y) max_y = parseInt(p);
      });

      if (max_y == 0) {
        max_y = doc.autoTable.previous.finalY + 30;
      } else {
        max_y += 5;
      }

      var numOfPages = doc.internal.getNumberOfPages();
      for (var i = 1; i <= numOfPages; i++) {
        doc.setPage(i);
        var footer_start = 5;
        if (logo !== null) {
          var f_width = doc.getImageProperties(logo).width;
          var f_height = doc.getImageProperties(logo).height;
          var f_aspect = f_width / f_height;
          f_width = 7 * f_aspect;
          doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
          footer_start += f_width + 10;
        }
        doc.setFontSize(8);
        doc.setTextColor(66, 75, 84);
        if (document_footer !== null)
          doc.text(document_footer, footer_start, 297 - 17);
        QRCode.toDataURL("Kartica " + this.client.name, function(err, url) {
          doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
        });
        doc.text(
          "Stranica " + String(i) + " od " + numOfPages,
          210 - 30,
          297 - 4
        );
        doc.setFontSize(6);
        doc.text(
          "Ovaj dokument je kreiran upotrebom SABIRA™ poslovnog rješenja. Za više informacija posjetite SABIRA.BA",
          10,
          297 - 4
        );
      }
      if (for_email) {
        var binary = doc.output();
        this.email.attachments.push({
          filename:
            "kartica_" + this.selected_year + "_" + this.client.name + ".pdf",
          content: binary,
          encoding: "binary",
        });
      } else {
        doc.save(
          "kartica_" + this.selected_year + "_" + this.client.name + ".pdf"
        );
      }
    },
    build_ios() {
      var final_list = [];
      this.email.subject = "Analitička kartica " + this.client.name;
      this.email.sender = {
        name: this.$store.getters.user.name,
        email: this.$store.getters.user.email,
      };
      this.email.recipients = [
        {
          name: this.client.name,
          email: this.client.email_address,
        },
      ];
      this.email.message =
        "Poštovana/ni, u prilogu se nalazi Analitička kartica zaključno sa " +
        this.datum_kreiranja_formatiran +
        ". god." +
        " " +
        "Molimo za provjeru i odgovor. Hvala.";
      this.get_payments().then((resp) => {
        if (resp.status == 200) {
          resp.data[0].forEach((uplata) => {
            final_list.push({
              date: new Date(uplata.uplaceno_datum).getTime(),
              description: "Uplata " + uplata.referenca,
              owes: null,
              paid: parseFloat(uplata.uplaceno_km),
              total: null,
            });
          });
          this.get_invoices().then((resp_inv) => {
            resp_inv.data[0].forEach((invoice) => {
              final_list.push({
                date: new Date(invoice.datum).getTime(),
                description:
                  (parseFloat(invoice.ukupno) > 0
                    ? "Faktura "
                    : "Storno faktura ") + invoice.broj,
                owes:
                  parseFloat(invoice.ukupno) > 0
                    ? parseFloat(invoice.ukupno)
                    : null,
                paid:
                  parseFloat(invoice.ukupno) < 0
                    ? parseFloat(invoice.ukupno) * -1
                    : null,
                total: null,
              });
            });
            final_list = final_list.length
              ? final_list.sort((a, b) => a.date - b.date)
              : final_list;
            var saldo = 0;
            final_list.forEach((x) => {
              if (x.paid !== null) {
                saldo = parseFloat(parseFloat(saldo) + parseFloat(x.paid));
              } else {
                saldo = parseFloat(parseFloat(saldo) - parseFloat(x.owes));
              }
              x.total = parseFloat(saldo);
            });
            this.items = final_list;
          });
        }
        this.is_loading = false;
      });
    },
    get_payments() {
      return this.$http({
        method: "POST",
        url: "/uplate",
        data: {
          account_id: this.$store.getters.user.account_id,
          klijent_id: this.client.id,
          year: this.selected_year,
        },
      });
    },
    get_invoices() {
      return this.$http({
        method: "POST",
        url: "/fakture",
        data: {
          account_id: this.$store.getters.user.account_id,
          klijent_id: this.client.id,
          type: 0,
          year: this.selected_year,
        },
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("close_email_dialog", () => {
        this.show_email = false;
      });
    },
  },
  computed: {
    datum_kreiranja_formatiran() {
      return this.$moment(new Date()).format("Do MMMM YYYY");
    },
    outstanding() {
      return parseFloat(this.paid - this.owes).toFixed(2);
    },
    paid() {
      return this.items.filter((x) => x.paid > 0).length
        ? this.items
            .filter((x) => x.paid > 0)
            .map((x) => x.paid)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
    owes() {
      return this.items.filter((x) => x.owes > 0).length
        ? this.items
            .filter((x) => x.owes > 0)
            .map((x) => x.owes)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
  },
  mounted() {
    this.setup_event_listeners();
    this.years.push(new Date().getFullYear());
    this.years.push(new Date().getFullYear() - 1);
  },
};
</script>
<style scoped>
.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
